import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Box, Button } from '@mui/material'
import { CheckCircleRounded } from '@mui/icons-material'
import { Body1, H3 } from '../../../../layouts/TextStyles'
import StartExamDialog from '../../../../components/dialogs/StartExamDialog'
import {
    CourseState,
    SectionDetailsState,
    SectionState,
    SubjectState,
    UserTopicState,
} from '../../../../features/types'

interface Props {
    section: SectionState
    topic: UserTopicState
    sectionDetails: SectionDetailsState
    subject: SubjectState
    course: CourseState
}

const styles = {
    wrapper: {
        display: 'grid',
        gridTemplateColumns: 'auto',
        gap: '16px',
        justifyContent: 'start',
        mb: 8,
    },
    flex: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    titleBox: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    circle: {
        fontSize: '24px',
    },
}

const QuizContent: React.FC<Props> = ({
    section,
    topic,
    sectionDetails,
    subject,
    course,
}) => {
    const { formatMessage } = useIntl()
    const navigate = useNavigate()

    const [openDialog, setOpenDialog] = useState(false)

    const handleClose = () => {
        setOpenDialog(false)
    }

    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.titleBox}>
                {sectionDetails.isFinished && (
                    <CheckCircleRounded
                        color="secondary"
                        sx={styles.circle}
                    />
                )}

                <H3>{section.title}</H3>
            </Box>

            <Body1>
                {formatMessage({ id: 'numberOfQuestions' })}:{' '}
                {sectionDetails.countQuestions}
            </Body1>

            <Body1>
                {formatMessage({ id: 'duration' })}: {sectionDetails.duration}
            </Body1>

            {!sectionDetails.isFinished ? (
                <Button
                    variant="contained"
                    onClick={() => setOpenDialog(true)}
                >
                    {formatMessage({ id: 'start' })}
                </Button>
            ) : (
                <Box>
                    <Box sx={{ mb: 2 }}>
                        {formatMessage({ id: 'testResult' })} -{' '}
                        {section.percentage}%
                    </Box>

                    <Button
                        style={{ color: '#ffffff' }}
                        variant="contained"
                        color="secondary"
                        onClick={() =>
                            navigate(`/my-courses/exam-result/${section.id}`, {
                                state: { course, subject },
                            })
                        }
                    >
                        {formatMessage({ id: 'workOnMistake' })}
                    </Button>
                </Box>
            )}

            <StartExamDialog
                title={section.title}
                open={openDialog}
                handleClose={handleClose}
                sectionDetails={sectionDetails}
                confirmAction={() =>
                    navigate(
                        `/exam/${section.id}?topic=${topic.courseTopicId}&user=${topic.userTopicEnrollId}&topicTestResultId=${sectionDetails.topicTestResultId}`,
                    )
                }
            />
        </Box>
    )
}

export default QuizContent
